import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik';
import ToggleUp from '../../../../Components/Icons/ToggleUp';
import ToggleDown from '../../../../Components/Icons/ToggleDown';
import * as yup from 'yup';
import { InputCheck, NuInput, NuTextArea } from '../../../../Components/Utils/Input';
import ScheduleLayout from './ScheduleLayout';
import CommonDynamicForm from '../../../../Components/Utils/CommonDynamicForm';
import axiosInstance from '../../../../Services/axiosCommon';
import { useToast } from '../../../../Components/Others/ToastServices';
import { useParams } from 'react-router-dom';
import NuDate from '../../../../Components/Utils/NuDate';

function Forms() {
  const { scheduleViewId } = useParams();

  const toast = useToast();
  
    const [allFormValues, setAllFormValues] = useState([]);
    const [allForm, setAllForm] = useState([]);
    const [allValue, setAllValue] = useState([]);
    useEffect(() => {
      if (scheduleViewId) fetchTasks(scheduleViewId);
    }, [scheduleViewId]);
  
    const fetchTasks = async (value) => {
      try {
        // setLoading(true);
        const response = await axiosInstance.get(`/schedules/forms/${value}`);
        console.log("Form ID", response.data?.data);
        let Data = response.data?.data;
        setAllFormValues(Data);
      } catch (error) {
        console.error("Error fetching tasks:", error);
      } finally {
        // setLoading(false);
      }
    };
  
    const [formId, setFormId] = useState(null);
  
    const fetchAllForm = async (value) => {
      setFormId(value);
      try {
        // setLoading(true);
        const formResponse = await axiosInstance.get(
          `/schedules/form-fields/${value}`
        );
        console.log(formResponse.data?.data);
        setAllForm(formResponse.data?.data);
        let TempArray = [];
        let tempFormData = formResponse.data?.data?.titles || [];
        tempFormData?.forEach((item) => {
          item?.fields?.forEach((field) => {
            console.log("Field - getting", field);
            let ValueInSide = {
              id: field?.id,
              field_type: field?.field_type,
              value: field?.value,
            };
            TempArray.push(ValueInSide);
          });
        });
        setAllValue(TempArray);
      } catch (error) {
        console.error("Error fetching tasks:", error);
      } finally {
        // setLoading(false);
      }
    };
  
    const [expandedIndex, setExpandedIndex] = useState(null);
  
    const handleToggle = (index, id) => {
      setAllForm([]);
      fetchAllForm(id);
      setExpandedIndex(index === expandedIndex ? null : index);
    };
  
    const formik = useFormik({
      enableReinitialize: true,
      initialValues: {},
      validationSchema: yup.object({}),
      validateOnChange: false,
      validateOnBlur: false,
      onSubmit: (values) => {
        let ValuesForForm = {
          "isSubmitted": true,
          "values": allValue,
        }
        let formData = new FormData();
        formData.append("json_data", JSON.stringify(ValuesForForm));
        axiosInstance.put(`/schedules/form-submition/${formId}`, formData).then((res)=>{
          console.log("Form Submitted", res.data);
          if(res.data?.status === true){
            toast.open({
              type:"success",
              message:"Success",
              description: res.data?.msg || "Created Successfully."
            })
          }else{
            toast.open({
              type:"error",
              message:"Error",
              description: res.data?.msg || "Network error."
            })
          }
        })
      },
    });
  
  
    function SaveFormData(){
      let ValuesForForm = {
        "isSubmitted": false,
        "values": allValue,
      }
      let formData = new FormData();
      formData.append("json_data", JSON.stringify(ValuesForForm));
      axiosInstance.put(`/schedules/form-submition/${formId}`, formData).then((res)=>{
        console.log("Form Submitted", res.data);
        if(res.data?.status === true){
          toast.open({
            type:"success",
            message:"Success",
            description: res.data?.msg || "Created Successfully."
          })
        }else{
          toast.open({
            type:"error",
            message:"Error",
            description: res.data?.msg || "Network error."
          })
        }
      })
    }
  
    return (
      <ScheduleLayout>
        <div className="w-full h-full mt-0.5 overflow-y-auto">
          {
            <div className="w-full mx-auto h-[calc(100vh-175px)] overflow-y-scroll bg-white rounded-lg shadow-md">
              {allFormValues?.map((item, index) => {
                return (
                  <>
                    <div
                      className="flex justify-between items-center p-2 cursor-pointer bg-slate-200"
                      onClick={() => handleToggle(index, item?.id)}
                    >
                      <h1 className="text-lg font-semibold ">
                        {item.formName || " - "}
                      </h1>
                      <div className="flex gap-6 items-center">
                        <div className=" flex items-center py-2 overflow-hidden rounded-lg text-[10px] 2xl:text-xs">
                          <div className=" py-2 h-10 bg-white px-3 rounded-s-lg font-medium flex items-center ">
                            Assignee :{" "}
                          </div>
                          <div className=" py-2 h-10 bg-blue-400 text-white font-medium px-3 rounded-e-lg flex items-center">
                            {item?.assginee || "Leo Messi"}
                          </div>
                        </div>
                        <div className=" flex items-center py-2 overflow-hidden rounded-lg text-[10px] 2xl:text-xs">
                          <div className=" py-2 h-10 bg-white px-3 rounded-s-lg font-medium flex items-center ">
                            Status :{" "}
                          </div>
                          <div className=" py-2 h-10 bg-green-400 text-white font-medium px-3 rounded-e-lg flex items-center">
                            Completed{" "}
                          </div>
                        </div>
                        <div className=" flex  items-center py-2 overflow-hidden rounded-lg text-[10px] 2xl:text-xs">
                          <div className=" py-2 h-10 bg-white  px-3 rounded-s-lg font-medium flex items-center ">
                            Completion Date :{" "}
                          </div>
                          <div className=" py-0.5 h-10 bg-yellow-400 px-3 text-white rounded-e-lg flex flex-col justify-center font-medium ">
                          <div className=" text-[10px] line-clamp-1"> <NuDate value={new Date()} format="DD-MM-YYYY" /></div>
                            <div className=" text-[9px]"><NuDate value={new Date()} format="hh:mm a" /></div>
                          </div>
                        </div>
                      </div>
                      <span 
                        onClick={() => handleToggle(index, item?.id)}
                        >
                        {expandedIndex === index ? <ToggleUp /> : <ToggleDown />}
                      </span>
                    </div>
                    <form onSubmit={formik.handleSubmit}>
                      <CommonDynamicForm
                        formData={allForm?.titles || []}
                        formik={formik}
                        expandedIndex={expandedIndex}
                        index={index}
                        allValue={allValue}
                        setAllValue={setAllValue}
                        SaveFormData={SaveFormData}
                      />
                    </form>
                  </>
                );
              })}
            </div>
          }
        </div>
      </ScheduleLayout>
    );
  }export default Forms
